import { IFormField } from './IForm.types';

export class FormioPipelineUtils {
  static getFormioOptions() {
    return {
      submitMessage: '',
      disableAlerts: true,
      noAlerts: true,
      nosubmit:true,
      noSubmit:true,

    };
  }

  // function to clean the output transform the default json result in a csv format
  // {
  //   utenti: "3",
  //   analytics: {
  //     B2B: false,
  //     B2C: true,
  //   },
  //   mail: "34",
  // }
  static cleanSubmissionData(submission: any) {
    const values = submission.data;
    delete values.submit;

    return Object.keys(values).reduce((acc, k: any) => {
      let value = values[k];
      if (typeof value === 'object') {
        value = Object.keys(value)
          .filter((k) => value[k])
          .join(', ');
      }
      return { ...acc, [k]: value };
    }, {});
  }

  static parseValueData(inputData: IFormField[], formValues) {
    if (!formValues) return {};
    const clonedValues = {...formValues}
    inputData
      .filter((f) => f.parameterType === 'checkbox_group' && clonedValues[f.key])
      .forEach((f) => {
        clonedValues[f.key] = clonedValues[f.key]
          .split(',')
          .map((v) => v.trim())
          .reduce((acc, v) => ({ ...acc, [v]: true }), {});
      });
    return {
      data: clonedValues,
    };
  }
}
